import Vue from 'vue';
import MessageBox from '@/components/messageBox.vue';

const MessageBoxConstructor = Vue.extend(MessageBox);

let messageBoxInstance = null;

const MessageBoxPlugin = {
	install(Vue) {
		Vue.prototype.$messageBox = function(options = {}) {
			// 如果已有弹窗存在，直接返回，避免重复弹出
			if (messageBoxInstance) {
				return;
			}

			// 默认参数
			const props = {
				title: options.title || '提示',
				message: options.message || '这是一个消息框',
				confirmText: options.confirmText || '确定',
				cancelText: options.cancelText || '取消',
				showCancel: options.showCancel,
				maskEvent: options.maskEvent,
				iconColor: options.iconColor,
				visible: true
			};

			// 创建 MessageBox 实例
			messageBoxInstance = new MessageBoxConstructor({
				propsData: props,
				el: document.createElement('div'),
			});

			// 挂载到 body 上
			document.body.appendChild(messageBoxInstance.$el);

			// 监听事件
			const confirmHandler = () => {
				if (options.onConfirm) options.onConfirm();
				closeMessageBox();
			};

			const cancelHandler = () => {
				if (options.onCancel) options.onCancel();
				closeMessageBox();
			};

			const maskHandler = () => {
				if (options.onMask) options.onMask();
				closeMessageBox();
			};

			const closeHandler = () => {
				closeMessageBox();
			};

			messageBoxInstance.$on('confirm', confirmHandler);
			messageBoxInstance.$on('cancel', cancelHandler);
			messageBoxInstance.$on('mask', maskHandler);
			messageBoxInstance.$on('close', closeHandler);

			// 销毁时移除事件监听和组件
			function closeMessageBox() {
				if (messageBoxInstance) {
					// 使用 Vue.nextTick 确保销毁操作完成后，再清空状态
					Vue.nextTick(() => {
						// 关闭组件
						messageBoxInstance.visible = false;

						// 移除事件监听
						messageBoxInstance.$off('confirm', confirmHandler);
						messageBoxInstance.$off('cancel', cancelHandler);
						messageBoxInstance.$off('close', closeHandler);

						// 销毁组件实例
						messageBoxInstance.$destroy();

						// 从 DOM 中移除组件的根节点
						messageBoxInstance.$el.remove();

						// 清空组件实例引用
						messageBoxInstance = null;
					});
				}
			}
		};
	},
};

export default MessageBoxPlugin;